import { render, staticRenderFns } from "./EditMultiQuestion.vue?vue&type=template&id=2c7b2aa2&scoped=true&"
import script from "./EditMultiQuestion.vue?vue&type=script&lang=js&"
export * from "./EditMultiQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EditMultiQuestion.vue?vue&type=style&index=0&id=2c7b2aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b2aa2",
  null
  
)

export default component.exports